import React, { useContext, useEffect, useState, useRef, useLayoutEffect } from "react";
import PropTypes from "prop-types";
import { useDispatch, useSelector } from "react-redux";
import { Link } from "react-router-dom";
import {
  TabContent,
  TabPane,
  Nav,
  NavItem,
  NavLink,
  Row,
  Col,
  Button,
  UncontrolledTooltip
} from "reactstrap";
import cx from "classnames";
import { COMPANY_SUPERADMIN } from "../../../constants/company";
import { getUserInfo } from "../../../store/actions/authActions";
import { documentInfo } from "../_utils";
import { Input } from "../../ui/input";
import { Icon } from "../../ui/icon";
import { ProcessLoader } from "../../ui/loader/processLoader";
import { useCheckCompanyPlanInfo } from "../../../hooks/useCheckCompanyPlanInfo";
import { useContextualUpgrade } from "../../../hooks/useContextualUpgrade";
import { EditorContext } from "../../../containers/editor/EditorLayout";
import {
  DOCUMENT_PUBLISH_SUCCESS,
  DOCUMENT_PUBLISH_FAILED,
  SEND_DOCUMENT_EMAIL_SUCCESS,
  FETCH_SENT_EMAIL_LIST_SUCCESS,
} from "../../../store/actions/actionTypes";
import {
  fetchDocumentDetails,
  publishDocument,
  sendDocumentEmail,
  fetchSentEmailList,
} from "../../../store/actions/documentActions";
import { useSocket } from "../../../hooks/useSocket";
import { PUBLISH_DOCUMENT, PUBLISH_DOCUMENT_DOWNLOAD, PUBLISH_DOCUMENT_PASSWORD } from "../../../constants/socket";
import { DotLoader } from "../../ui/loader/dotLoader";
import global from "../../../scss/dhp.scss";
import { DataFormatter } from "../../ui/dataFormatter";
import { getCompanyInfo } from "../../../store/actions/companyActions";
import Settings from "./Settings";

let style = Object.assign({}, global);

const EmailModal = ({ document: data, _helpers }) => {
  const suggestionBoxWidth = 258;
  const unPaidEmailRestriction = 1;
  const paidEmailRestriction = 10;
  const fetch = {
    page: 1,
    limit: 25,
  };


  let { pageNodes, blockNodes, backgroundColors, backgroundImages, widgets, dimension, documentType } =
    useContext(EditorContext);
  const webSocket = useSocket();
  const dispatch = useDispatch();
  const showUpgrade = useContextualUpgrade();
  const paidCompanyInfo = useCheckCompanyPlanInfo(true);
  const modifiedData = { ...data.publish, publish_id: data?.publish?.hash, id: data?.id };
  const dateFormat = (useSelector(state => state?.auth?.user?.date_format) || "MM-DD-YYYY").replaceAll("-", "/");

  const alertData = {
    show: false,
    type: "",
  };

  const errorTypes = [
    DOCUMENT_PUBLISH_FAILED,
  ];

  const { exists: isPublished, data: publishId } = documentInfo.get(modifiedData, "publish_id");

  const initialState = {
    email: {
      payload: {
        toRecipients: [],
        emailSubject: "",
        publishLink: "",
      },
    },
    sentEmail: {},
    tab: "email",
    published: isPublished,
    publish_id: publishId,
    toggle_publish: isPublished,
  };

  const [state, setState] = useState(initialState);
  const [isMounted, setIsMounted] = useState(false);
  const [alert, setAlert] = useState(alertData);
  const [disable, setDisable] = useState({
    share: false,
    shared_with: false,
    publish: false,
  });
  const [step, setStep] = useState(1);
  const [isUserDocumentOwner, setIsUserDocumentOwner] = useState(false);
  const [totalEmailCount, setTotalEmailCount] = useState({
    threeRecipients: false,
    tenRecipients: false,
    notifyUser: false,
    showMessage: false,
  });
  const [emailSentCount, setEmailCount] = useState(0);
  const [sentEmailRestriction, setSentEmailRestriction] = useState({
    oneEmailPerDay: false,
    tenEmailPerDay: false,
    emailRestrictionMessage: false,
  });
  const [sentEmailRestrictionCount, setSentEmailRestrictionCount] = useState(0);
  const [emailSendError, setEmailSendError] = useState(false);
  const [sentEmailFirstTime, setSentEmailFirstTime] = useState(false);
  const [disabledSendButton, setDisabledSendButton] = useState(false);
  const [delayedSentEmail, setDelayedSentEmail] = useState(false);
  const [nextClickDisable, setNextClickDisable] = useState(false);

  const companyId = useSelector(state => state?.auth?.user?.company?.id);
  const userInfo = useSelector(state => state?.auth?.user);
  const { type, hash_code: publish_id, documentDetails, lodingEmailList, loadingEmailSend } = useSelector(
    state => state?.document
  );
  const time_format = useSelector(state => state?.auth?.user?.time_format);

  const handleBack = () => {
    if (emailSendError) setEmailSendError(false);
    setNextClickDisable(false);
    setStep(1);
  };

  const handleEmailCount = state => setTotalEmailCount({ ...totalEmailCount, showMessage: state });

  const handleSentEmailCount = (total_count, sent_EmailCount) => {
    setEmailCount(total_count);
    setSentEmailRestrictionCount(sent_EmailCount);

    if (paidCompanyInfo?.isPaid && !paidCompanyInfo?.isLoading) {
      const validateEmailRestriction = sent_EmailCount >= paidEmailRestriction;
      setSentEmailRestriction({
        oneEmailPerDay: false,
        tenEmailPerDay: validateEmailRestriction,
        emailRestrictionMessage: validateEmailRestriction,
      });
    } else if (!paidCompanyInfo?.isPaid && !paidCompanyInfo?.isLoading) {
      const validateEmailRestriction = sent_EmailCount >= unPaidEmailRestriction;
      setSentEmailRestriction({
        oneEmailPerDay: validateEmailRestriction,
        tenEmailPerDay: false,
        emailRestrictionMessage: validateEmailRestriction,
      });
    }
  };

  const handleEmailSend = () => {
    setDisabledSendButton(true);
    const documentData = documentDetails?.data?.owner;
    const emailPayload = state.email.payload;
    const payload = {
      sender_name: userInfo?.name,
      sender_email: userInfo?.email,
      to: emailPayload.toRecipients,
      subject: emailPayload.emailSubject,
      publish_url: emailPayload.publishLink,
      body: `${userInfo?.name} has sent you the following document.`,
    };

    dispatch(sendDocumentEmail(documentDetails?.data?.id, payload)).then(r => {
      if (r.type === SEND_DOCUMENT_EMAIL_SUCCESS) {
        setDelayedSentEmail(true);
        setTimeout(() => {
          if (emailSentCount === 0) setSentEmailFirstTime(true);

          if (localStorage.getItem("emailCount")) {
            const count = parseInt(localStorage.getItem("emailCount"));
            localStorage.setItem("emailCount", JSON.stringify(count + 1));
          } else localStorage.setItem("emailCount", JSON.stringify(sentEmailRestrictionCount + 1));

          dispatch(fetchSentEmailList(documentDetails?.data?.id, fetch)).then(r => {
            if (r.type === FETCH_SENT_EMAIL_LIST_SUCCESS) updateState({ field: "tab", value: "sentEmail" });
          });
          setDelayedSentEmail(false);
          let stateObj = { ...state };
          stateObj.email.payload.toRecipients = [];
          setState(stateObj);
        }, 5000);
      } else setEmailSendError(true);
    });
  };

  const handleUpgrade = () => setTotalEmailCount({ ...totalEmailCount, clickedUpgrade: true });

  const upgradeToTenRecipients = () => {
    if (paidCompanyInfo?.companyRole === COMPANY_SUPERADMIN && !paidCompanyInfo?.isPaid) {
      // Call showUpgrade function to show contexttual upgrade modal based on your condition
      showUpgrade("addTenRecipientsDocumentLink", {
        docPagesMeta: { pageNodes, blockNodes, backgroundColors, backgroundImages, widgets, dimension, documentType },
      });
    }
  };

  const upgradeToTenEmails = () => {
    if (paidCompanyInfo?.companyRole === COMPANY_SUPERADMIN && !paidCompanyInfo?.isPaid) {
      // Call showUpgrade function to show contexttual upgrade modal based on your condition
      showUpgrade("sendTenEmailDocumentLink", {
        docPagesMeta: { pageNodes, blockNodes, backgroundColors, backgroundImages, widgets, dimension, documentType },
      });
    }
  };

  const toggleAlert = () => setAlert({ ...alert, show: !alert.show });

  const generatePublishCode = () => {
    // const publishUrl = `${process.env.BASE_URL}/pub/${userInfo?.company?.id}/documents/${state.publish_id}`;
    const publishUrl = `${process.env.PUBLIC_PAGE_BASE_URL}/p/${state.publish_id}`;

    // Update the publishLink in the state
    let stateObj = { ...state };
    stateObj.email.payload.publishLink = publishUrl;
    setState(stateObj);
  };

  const handlePublishButtonClick = () => {
    if (!state.published && isUserDocumentOwner) {
      let stateObj = { ...state };

      stateObj.toggle_publish = true;
      setState(stateObj);
      setIsMounted(true);
      setNextClickDisable(true);
      dispatch(publishDocument([data.id])).then(r => {
        if (r.type === DOCUMENT_PUBLISH_SUCCESS) {
          setDisable({ ...disable, publish: true, unset_download: false, set_download: false });
          setStep(2);
        }
      });
    } else {
      const emailCount = parseInt(localStorage.getItem("emailCount"));

      if (!paidCompanyInfo?.isLoading) {
        let sentEmailRestrictionUpdated = {
          oneEmailPerDay: false,
          tenEmailPerDay: false,
          emailRestrictionMessage: false,
        };

        if (
          !paidCompanyInfo?.isPaid &&
          (sentEmailRestrictionCount >= unPaidEmailRestriction || emailCount >= unPaidEmailRestriction)
        )
          sentEmailRestrictionUpdated = {
            ...sentEmailRestrictionUpdated,
            oneEmailPerDay: true,
            emailRestrictionMessage: true,
          };
        else if (
          paidCompanyInfo?.isPaid &&
          (sentEmailRestrictionCount >= paidEmailRestriction || emailCount >= paidEmailRestriction)
        )
          sentEmailRestrictionUpdated = {
            ...sentEmailRestrictionUpdated,
            tenEmailPerDay: true,
            emailRestrictionMessage: true,
          };
        else setStep(2);

        setSentEmailRestriction(sentEmailRestrictionUpdated);
      }
    }
  };

  const updateState = ({ field, value, type, e }) => {
    let stateObj = { ...state };

    if (["toRecipients", "emailSubject"].includes(field)) {
      stateObj.email.payload[field] = value;
      setState(stateObj);
    }

    if (field === "tab" && stateObj.tab !== value) {
      stateObj.tab = value;
      setState(stateObj);
    }

    if (field === "publish_proposal_settings") {
      if (e !== "") {
        stateObj.proposal_settings.value = e;
        setState(stateObj);
      }
    }

    if (field === "proposal_status") {
      stateObj.proposal_settings.status = e;
      setState(stateObj);
    }
  };

  const postApiCallActions = () => {
    let stateObj = { ...state };

    if (type === DOCUMENT_PUBLISH_SUCCESS) {
      setIsMounted(false);
      documentInfo.set(data, { publish_id: publish_id });
      stateObj.published = true;
      stateObj.publish_id = publish_id;
      stateObj.toggle_publish = true;
      setState(stateObj);
      // check is web socket is in ready state
      if (webSocket?.readyState === 1) {
        const subscribe = { type: PUBLISH_DOCUMENT, data, publish_id: publish_id };
        webSocket.send(JSON.stringify(subscribe));
      }
    }

    if (errorTypes.includes(type)) {
      setIsMounted(false);
      setAlert({ ...alert, show: true, type: "error" });
    }
  };

  useEffect(() => {
    const totalCount = state.email.payload.toRecipients.length;
    const isThreeRecipients = totalCount === 3;
    const isTenRecipients = totalCount === 10;
    if ((isThreeRecipients && !paidCompanyInfo?.isPaid) || (isTenRecipients && paidCompanyInfo?.isPaid))
      setTotalEmailCount({ threeRecipients: isThreeRecipients, tenRecipients: isTenRecipients, notifyUser: true });
    else if (totalEmailCount.notifyUser)
      setTotalEmailCount({ threeRecipients: false, tenRecipients: false, notifyUser: false });
  }, [state.email.payload.toRecipients]);

  useEffect(() => {
    updateState({ field: "emailSubject", value: documentDetails?.data?.document_name ?? "" });
  }, [documentDetails]);

  useEffect(() => {
    if (isMounted && type) postApiCallActions();
  }, [type, isMounted]);

  useEffect(() => {
    if (state.published && userInfo) generatePublishCode();
  }, [state.published, userInfo]);

  useEffect(() => {
    if (userInfo) setIsUserDocumentOwner(data?.permission === "OWNER");
  }, [userInfo]);

  useEffect(() => {
    if (!documentDetails && documentDetails?.data?.id !== data?.id) dispatch(fetchDocumentDetails(data?.id));
  }, [data?.id]);

  useEffect(() => {
    if (state.tab === "sentEmail") setDisabledSendButton(false);
  }, [state.tab]);

  useEffect(() => {
    if (!userInfo) dispatch(getUserInfo());
    return () => {
      localStorage.removeItem("emailCount");
    };
  }, []);

  return (
    <React.Fragment>
      <div className={style["modal-header"]}>
        <h4 className={cx(style["fw-7"], style["mb-0"])}>Email</h4>
        <Link to="#" className={cx(style["cross-modal"], style["rounded"])} onClick={_helpers?.modal?.toggle}>
          <Icon icon="ui-close" />
        </Link>
      </div>
      <div className={cx(style["modal-tab"], style["row"], style["m-0"])}>
        <div className={cx(style["col-4"], style["p-0"])}>
          <Nav className={cx(style["nav-pills"], style["flex-column"], style["h-100"])}>
            <NavItem>
              <NavLink
                className={cx({ [style["active"]]: state.tab === "email" })}
                onClick={() => {
                  setStep(1);
                  updateState({ field: "tab", value: "email" });
                }}>
                <Icon icon="ui-email" /> Email
              </NavLink>
            </NavItem>
            <NavItem>
              <NavLink
                className={cx({ [style["active"]]: state.tab === "sentEmail" })}
                onClick={() => updateState({ field: "tab", value: "sentEmail" })}>
                <Icon icon="ui-secured-email" /> Sent Email
                <span className={style["numberof-shared"]}>{emailSentCount}</span>
              </NavLink>
            </NavItem>
          </Nav>
        </div>
        <div className={cx(style["col-8"], style["p-0"])}>
          <TabContent className={style["overflow-visible"]} activeTab={state.tab}>
            <TabPane tabId="email" className={style["email"]}>
              <div className={style["pe-2"]}>
                <div className={cx(style["content-wrap"], style["pe-4"], style["mb-3"])}>
                  {step === 1 && (
                    <section>
                      <Col className={cx(style["p-0"], style["mb-3"])}>
                        <div className={cx(style["tocc-wrap"])}>
                          <Input
                            id="ToRecipients"
                            returnType="formGroup"
                            type="email_recipient"
                            label="To"
                            width="100px"
                            disabled={sentEmailRestriction.emailRestrictionMessage}
                            suggestionBoxWidth={suggestionBoxWidth}
                            clickedUpgrade={totalEmailCount?.clickedUpgrade}
                            userNotify={totalEmailCount?.notifyUser}
                            handleEmailCount={handleEmailCount}
                            defaultValue={state?.email.payload.toRecipients}
                            updateState={e => updateState({ field: "toRecipients", value: e })}
                          />
                        </div>
                      </Col>
                      <Col className={cx(style["p-0"])}>
                        <div className={cx(style["subject"])}>
                          <Input
                            cssModule={style}
                            returnType="formGroup"
                            type="text"
                            disabled={sentEmailRestriction.emailRestrictionMessage}
                            placeholder={"Subject"}
                            value={state.email.payload.emailSubject}
                            onChange={e => updateState({ field: "emailSubject", value: e.target.value })}
                          />
                        </div>
                      </Col>

                      <Col className={cx(style["p-0"])}>
                        <div>
                          <h6
                            className={cx(style["d-flex"], style["align-items-center"], style["mb-3"], style["fw-6"])}>
                            <Icon additionalclass={"font-base me-2"} icon="ui-info" />
                            How your email will look
                          </h6>
                          <div className={cx(style["card"], style["email-card"])}>
                            <div className={style["card-body"]}>
                              <div className={style["card-header"]}>
                                <h6 className={cx(style["m-0"], style["fw-6"], style["font-15"])}>
                                  {documentDetails?.data?.document_name}
                                </h6>
                              </div>
                              <p>{userInfo?.name} has sent you the following document.</p>
                              <div className={cx(style["d-flex"], style["justify-content-center"])}>
                                <span className={cx(style["btn-border"])}>View Document</span>
                              </div>
                            </div>
                          </div>
                        </div>
                      </Col>
                    </section>
                  )}

                  {step === 2 && (
                    <section>
                      <Settings source={"email-modal"} data={data} _helpers={_helpers} />
                    </section>
                  )}
                </div>

                <div className={cx(style["align-items-center"], style["d-flex"])}>
                  <div className={cx(style["btn-wrp-bg"], style["d-flex"])}>
                    {step === 1 && (
                      <div className={cx(style["d-flex"], style["align-items-center"])}>
                        <Button
                          type="submit"
                          color="primary"
                          cssModule={style}
                          disabled={
                            state?.email?.payload?.toRecipients?.length === 0 ||
                            state?.email?.payload?.emailSubject?.trim() === "" ||
                            (sentEmailRestriction.emailRestrictionMessage && !totalEmailCount.showMessage) ||
                            nextClickDisable
                          }
                          onClick={handlePublishButtonClick}>
                          Next
                        </Button>

                        {sentEmailRestriction.emailRestrictionMessage && (
                          <div className={cx(style["d-flex"], style["flex-column"], style["ms-3"])}>
                            {sentEmailRestriction.oneEmailPerDay && (
                              <>
                                <span className={style["color-red"]}>{`${unPaidEmailRestriction} email/day`}</span>
                                <span
                                  className={cx(style["color-black"], "restrict-blur")}
                                  onClick={() => {
                                    upgradeToTenEmails();
                                  }}>
                                  <u className={style["cursor-pointer"]}>Upgrade for more</u>
                                </span>
                              </>
                            )}
                            {sentEmailRestriction.tenEmailPerDay && (
                              <>
                                <span
                                  className={
                                    style["color-red"]
                                  }>{`You can send ${paidEmailRestriction} emails/day`}</span>
                              </>
                            )}
                          </div>
                        )}

                        {totalEmailCount.showMessage && !sentEmailRestriction.emailRestrictionMessage && (
                          <div className={cx(style["d-flex"], style["flex-column"], style["ms-3"])}>
                            {totalEmailCount.threeRecipients && (
                              <>
                                <span className={style["color-red"]}>You can add up to 3 recipients/email</span>
                                <span
                                  className={cx(style["color-black"], "restrict-blur")}
                                  onMouseDown={() => handleUpgrade()}
                                  onClick={() => {
                                    upgradeToTenRecipients();
                                    setTotalEmailCount({ ...totalEmailCount, clickedUpgrade: false });
                                  }}>
                                  <u className={style["cursor-pointer"]}>Upgrade for more</u>
                                </span>
                              </>
                            )}
                            {totalEmailCount.tenRecipients && (
                              <>
                                <span className={style["color-red"]}>You can add up to 10 recipients/email</span>
                              </>
                            )}
                          </div>
                        )}
                        <ProcessLoader isOpen={!state.published && state.toggle_publish} />
                      </div>
                    )}

                    {step === 2 && (
                      <div className={cx(style["d-flex"], style["align-items-center"])}>
                        <Button
                          type="submit"
                          color="primary"
                          cssModule={style}
                          disabled={disabledSendButton}
                          className={cx(style["me-2"])}
                          onClick={handleEmailSend}>
                          Send
                        </Button>
                        <Button type="button" className="btn-border" cssModule={style} onClick={handleBack}>
                          Back
                        </Button>
                        <ProcessLoader
                          isOpen={
                            (lodingEmailList ?? false) || (loadingEmailSend ?? false) || (delayedSentEmail ?? false)
                          }
                        />
                        {emailSendError && (
                          <div className={cx(style["d-flex"], style["flex-column"], style["ms-3"])}>
                            <>
                              <span className={style["color-red"]}>The email couldn’t be sent.</span>
                              <span className={cx(style["color-red"])}>Please try again later.</span>
                            </>
                          </div>
                        )}
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </TabPane>
            <TabPane tabId="sentEmail" className={style["sentEmail"]}>
              <Row>
                <Col sm="12">
                  <div className={cx(style["content-wrap"])}>
                    <EmailTable
                      stateTable={state}
                      sentEmailFirstTime={sentEmailFirstTime}
                      handleSentEmailCount={handleSentEmailCount}
                      timeFormat={time_format}
                    />
                  </div>
                </Col>
              </Row>
            </TabPane>
          </TabContent>
        </div>
      </div>
    </React.Fragment>
  );
};

const EmailTable = ({ sentEmailFirstTime, handleSentEmailCount, timeFormat, stateTable }) => {
  const dispatch = useDispatch();
  const loadMoreRef = useRef();
  const tableRef = useRef(null);
  let hasMore = false;
  const fetch = {
    page: 1,
    limit: 25,
  };
  const configInfo = {
    component: {
      isStatic: true,
      tableClass: "trash-table",
      name: "Sent Email",
      slug: "sent_email",

      no_record_info: {
        text: "No records found.",
      },
    },
    appearance: {
      generic_actions: {
        ui: {
          component_info: true,
        },
      },
    },
    list_view: {
      columns: [
        {
          name: "Date",
          slug: "created_on",
          type: "date-time",
          format: "default",
          display: true,
        },
        {
          name: "Recipient",
          slug: "record",
          type: "dataobj",
          display: true,
        },
      ],
    },
  };
  const IntersectOptions = {
    root: null,
    rootMargin: "0px",
    threshold: 0,
  };

  const [payloadFetch, setPayloadFetch] = useState(fetch);
  const [availableTableData, setAvailableTableData] = useState([]);
  const [fetchingEmailListError, setFetchingEmailListError] = useState(false);

  const { documentDetails, sentEmailList, lodingEmailList } = useSelector(state => state?.document);
  const { total_count: totalCount = 0, email_sent: sent_EmailCount = 0 } = sentEmailList ?? {
    total_count: 0,
    email_sent: 0,
  };

  const fetchRecords = () =>
    dispatch(fetchSentEmailList(documentDetails?.data?.id, payloadFetch)).then(r => {
      if (r.type !== FETCH_SENT_EMAIL_LIST_SUCCESS) setFetchingEmailListError(true);
    });
  const loadMore = () => setPayloadFetch({ ...payloadFetch, page: payloadFetch.page + 1 });

  const handleIntersect = entries => {
    if (entries[0].isIntersecting && hasMore) loadMore();
  };

  const handleRefreshEmailList = () => {
    setPayloadFetch(fetch);
    setFetchingEmailListError(false);
  };

  useLayoutEffect(() => {
    handleSentEmailCount(totalCount, sent_EmailCount);
  }, [sentEmailList]);

  useEffect(() => {
    if (sentEmailList?.shared_email)
      setAvailableTableData(
        payloadFetch.page > 1 ? [...availableTableData, ...sentEmailList?.shared_email] : sentEmailList?.shared_email
      );
    if (totalCount > 0) {
      const lastPage = Math.floor(
        totalCount % payloadFetch.limit === 0 ? totalCount / payloadFetch.limit : totalCount / payloadFetch.limit + 1
      );
      hasMore = payloadFetch.page < lastPage;
    }

    const observer = new IntersectionObserver(handleIntersect, IntersectOptions);
    if (loadMoreRef.current) observer.observe(loadMoreRef.current);
    return () => {
      if (loadMoreRef.current) observer.unobserve(loadMoreRef.current);
    };
  }, [sentEmailList, loadMoreRef]);

  useEffect(() => {
    fetchRecords();
  }, [payloadFetch]);

  useEffect(() => {
    if (stateTable.tab === "sentEmail" && tableRef.current) {
      let maxWidth = 0;

      const rows = tableRef.current.querySelectorAll("tbody tr");
      rows.forEach(cell => {
        if (cell.querySelector("td div") && cell.querySelector("td").clientWidth > maxWidth)
          maxWidth = cell.querySelector("td").clientWidth;
      });
      document.querySelector("#sent-email-table thead tr th").style.width = maxWidth + "px";
    }
  }, [stateTable.tab]);

  return (
    <div className={cx(style["table-info-wrap"], style["h-100"])}>
      {availableTableData?.length >= 1 && !fetchingEmailListError && (
        <div className={cx(style["table-responsive-custom"], style["customScroll"], style["scroll-X"])}>
          <table
            id="sent-email-table"
            ref={tableRef}
            className={cx(style["table"], style["table-borderless"], {
              [style["table-12-hours"]]: timeFormat === "12 Hours",
            })}>
            <thead>
              {availableTableData && (
                <tr>
                  {configInfo.list_view.columns.map((column, i) => (
                    <th key={i} style={column?.customStyle}>
                      {column.name}
                      {column.slug === "record" && (
                        <div className={cx(style["custom-tooltip"])}>
                          <>
                            <Icon
                              onClick={() => handleRefreshEmailList()}
                              icon="ui-rotate-right"
                              additionalclass={"cursor-pointer"}
                            />
                            <div className={cx(style["custom-tooltip-content"], style["left"])}>
                              Refresh to see the latest data
                            </div>
                          </>
                        </div>
                      )}
                    </th>
                  ))}
                </tr>
              )}
            </thead>
            <tbody className={cx(style["customScroll"], style["scroll-Y"])}>
              {availableTableData?.map((data, i) => (
                <tr key={i}>
                  <td>
                    <DataFormatter
                      type={configInfo.list_view.columns[0].type}
                      slug={configInfo.list_view.columns[0].slug}
                      format={configInfo.list_view.columns[0].format}
                      data={data}
                    />
                  </td>
                  <td>
                    <span
                      className={cx(style["d-flex"], style["align-items-center"], style["justify-content-between"])}>
                      <span>{data?.recipient[0]}</span>
                      {data?.recipient?.length > 1 && (
                        <span id={`emailCounter${i}`} className={cx(style["email-count"])}>{`+${
                          data?.recipient?.length - 1
                        }`}</span>
                      )}
                    </span>

                    {data?.recipient?.length > 1 && (
                      <UncontrolledTooltip
                        placement="bottom"
                        target={`emailCounter${i}`}
                        trigger="hover"
                        arrowClassName="d-none"
                        className={cx(style["email-list-tooltip"])}>
                        {data?.recipient?.map((val, i) => (
                          <span key={i}>
                            {val}
                            <br />
                          </span>
                        ))}
                      </UncontrolledTooltip>
                    )}
                  </td>
                </tr>
              ))}

              {lodingEmailList && payloadFetch.page > 1 && <DotLoader />}
              {!lodingEmailList && (
                <tr>
                  <td colSpan="2" style={{ height: "20px" }} ref={loadMoreRef}></td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      )}
      {(availableTableData?.length === 0 || fetchingEmailListError || sentEmailFirstTime) && (
        <div
          className={cx(
            style["d-flex"],
            style["align-items-center"],
            style["justify-content-center"],
            style["h-75"],
            style["pt-5"],
            style["text-center"]
          )}>
          {availableTableData?.length === 0 && !sentEmailFirstTime && !fetchingEmailListError && (
            <>The document is not sent to anyone</>
          )}
          {(fetchingEmailListError || (sentEmailFirstTime && availableTableData?.length === 0)) && (
            <>
              It might take some time to show the data
              <br />
              here. You may please close the window
              <br />
              and come back later.
            </>
          )}
        </div>
      )}
    </div>
  );
};

EmailTable.propTypes = {
  sentEmailFirstTime: PropTypes.bool,
  handleSentEmailCount: PropTypes.func.isRequired,
};

EmailModal.propTypes = {
  document: PropTypes.object.isRequired,
  _helpers: PropTypes.object.isRequired,
};

export default EmailModal;
